<template>
  <v-card>
    <v-toolbar card color="white">
      <v-text-field
        v-model="search"
        flat
        hide-details
        :placeholder="$t('action.buttons.search')"
        prepend-icon="search"
        solo
      />
      <meta-button type="new" @click="$emit('form')" />
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="formatedList"
        :rows-per-page-items="[
          10,
          25,
          50,
          { text: $t('action.buttons.all'), value: -1 },
        ]"
        disable-initial-sort
        :loading="loading"
        :search="search"
      >
        <!-- :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"
        -->
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-icon
              color="success"
              class="mr-1"
              @click="setOne(props.item.iso)"
            >
              edit
            </v-icon>
            <v-icon color="error" @click="ifDelete(props.item.iso)">
              delete
            </v-icon>
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td>
          <td>{{ props.item.name }}</td>
          <td class="text-xs-center">
            {{ props.item.iso }}
          </td>
          <td>{{ props.item.order }}</td>
          <td class="text-xs-center">
            {{ props.item.createdAt }}
          </td>
          <td>{{ props.item.createdBy }}</td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item.iso)"
              >visibility</i
            >
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(isoDelete)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
  </v-card>
</template>

<script>
import { debounce } from 'debounce'
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'

export default {
  name: 'LanguageList',
  components: { DialogDelete, DialogUpdatedRecord },
  data() {
    return {
      search: '',
      isoDelete: '',
      dialogDelete: false,
      dialogUpdated: false,
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    // search(val) {
    //   if (this.localPagination.page !== 1) this.localPagination.page = 1
    //   else this.debounceFetch()
    // },
    // 'localPagination.page': {
    //   handler: function(val, oldVal) {
    //     this.fetchList({ match: this.search })
    //   }
    // }
  },
  computed: {
    ...mapState({
      loading: (state) => state.languages.loading,
      selected: (state) => state.languages.selected,
      pagination: (state) => state.languages.pagination,
    }),
    ...mapGetters({
      formatedList: 'languages/formatedList',
    }),
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active',
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
        },
        {
          text: this.$t('fields.language.iso'),
          align: 'center',
          value: 'iso',
        },
        {
          text: this.$t('fields.global.order'),
          value: 'order',
        },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
        },
        {
          text: this.$t('fields.global.createdBy'),
          value: 'createdBy',
        },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('languages/setPagination', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'languages/fetchOne',
      setDelete: 'languages/delete',
      reset: 'languages/reset',
      fetchList: 'languages/fetchList',
    }),
    setOne(id) {
      this.fetchOne(id).then((_) => this.$emit('form'))
    },
    openUpdated(id) {
      this.fetchOne(id).then((_) => (this.dialogUpdated = true))
    },
    ifDelete(iso) {
      this.isoDelete = iso
      this.dialogDelete = true
    },
    _setDelete(iso) {
      this.setDelete(iso).finally(() => (this.dialogDelete = false))
    },
    debounceFetch: debounce(function () {
      this.fetchList({
        match: this.search,
      })
    }, 1000),
  },
}
</script>
